// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/placeholder-row","root":"placeholder-row-m__root__3mHcS"};